import React from "react";

const CustomToast = ({ children, appearance, onDismiss }) => {
  const icons = {
    success: "✓",
    error: "×",
    warning: "!",
    info: "i",
  };

  return (
    <div className={`my-toast my-toast-${appearance || "info"}`}>
      <div className="my-toast-icon">{icons[appearance] || icons.info}</div>

      <div className="my-toast-content">{children}</div>

      {onDismiss && (
        <button
          type="button"
          className="my-toast-close"
          onClick={onDismiss}
          aria-label="Close notification"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default CustomToast;
